
<template>
  <el-dialog
    title="导入讨论会"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="detailForm"
      :rules="rules"
      :model="model"
    >
      <el-table :data="model.uploadData">
        <!-- 议题 -->

        <el-table-column label="议题" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.yiTi'"
              :rules="rules.yiTi"
            >
              <el-input
                v-model="scope.row.yiTi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 时间 -->
        <el-table-column label="时间" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.shiJian'"
              :rules="rules.shiJian"
            >
              <el-date-picker
                v-model="scope.row.shiJian"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 地点 -->

        <el-table-column label="地点" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.diDian'"
              :rules="rules.diDian"
            >
              <el-input
                v-model="scope.row.diDian"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 组织者 -->

        <el-table-column label="组织者" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.zuZhiZhe'"
              :rules="rules.zuZhiZhe"
            >
              <el-input
                v-model="scope.row.zuZhiZhe"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 记录者 -->

        <el-table-column label="记录者" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jiLuZhe'"
              :rules="rules.jiLuZhe"
            >
              <el-input
                v-model="scope.row.jiLuZhe"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 会议纪要 -->

        <el-table-column label="会议纪要" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.huiYiJiYao'"
              :rules="rules.huiYiJiYao"
            >
              <el-input
                v-model="scope.row.huiYiJiYao"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 备注 -->

        <el-table-column label="备注" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.beiZhu'"
              :rules="rules.beiZhu"
            >
              <el-input
                v-model="scope.row.beiZhu"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              <el-button
                type="text"
                size="small"
                @click.stop="handleRowDel( scope.row,scope.$index)"
              >
                删除
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleUploadData('detailForm')"
      >保  存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'

export default {
  components: { },
  props: {
    value: Boolean,
    uploadData: { type: Array, default: null }},
  data() {
    return {
      model: { uploadData: {}},
      allComboxData: [],
      formCode: 'xs0104',
      rules: {
        yiTi: [
          { required: true, message: '请输入议题', trigger: 'change,blur' }
        ],
        shiJian: [
          { required: true, message: '请输入时间', trigger: 'change,blur' }
        ],
        diDian: [
          { required: true, message: '请输入地点', trigger: 'change,blur' }
        ]
      }
    }
  },
  watch: {
    uploadData: function() {
      this.model.uploadData = this.uploadData
    }
  },
  mounted: function() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray().then(res => {
      this.allComboxData = res.data.result
    })
    this.model.uploadData = this.uploadData
  },
  methods: {
    handleOpenDailog() {},
    handleCloseDailog() {
      this.$emit('input', false)
    },
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 保存数据
    handleUploadData() {
      this.$refs['detailForm'].validate(valid => {
        if (valid) {
          const url = '/api/services/app/xs0104/ImportCreatexs0104'
          pathReq.postForm(url,
            { entityList: this.model.uploadData }
          ).then(() => {
            this.$message.success('导入成功')
            this.$emit('input', false)
            this.$emit('save-success')
          })
        }
      })
    },
    handleRowDel(row, index) {
      this.model.uploadData.splice(index, 1)
    }
  }
}
</script>
